import api from './api';

const achievementService = {
  /**
   * List achievements (positive recognition / good practice), optionally
   * filtered by project/category.
   */
  async getAll(params = {}) {
    const response = await api.get('/achievements', { params });
    return response.data;
  },

  /**
   * Record a new achievement.
   */
  async create(achievementData) {
    const response = await api.post('/achievements', achievementData);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/achievements/${id}`);
    return response.data;
  },
};

export default achievementService;
